(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/reducer.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/reducer.js');

const {
  UPDATE_CUSTOMERINFO_FORM,
  UPDATE_ARTICLES,
  ACCEPT_TERMS,
  ORDER_SUCCESS,
  CLEAR_STATE
} = svs.ticket_partner.physicalTickets.actions;

const initialState = (cmsArticles) => ({
  adressForm: {
    companyName: '',
    organizationNumber: '',
    contact: '',
    address1: '',
    zip: '',
    city: '',
    phone: '',
    eMail: '',
    deliveryAddress: '',
    deliverLatest: '',
    message: ''
  },
  articles: cmsArticles?.reduce((result, article) => {
    if (!result[article?.ticketId]) {
      result[article.ticketId] = {
        count: 0,
        articleId: article.ticketId,
        price: article.price,
        name: article.ticketTitle
      };
    }
    return result;
  }, {}) || {},
  terms_and_conditions: false,
  orderSuccess: false
});

svs.ticket_partner.physicalTickets.initialState = initialState;

svs.ticket_partner.physicalTickets.reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CUSTOMERINFO_FORM:
      return {
        ...state,
        adressForm: {
          ...state.adressForm, [payload.field]: payload.value
        }
      };
    case UPDATE_ARTICLES:
      return {
        ...state,
        articles: {
          ...state.articles, [payload.articleId]: {
            ...payload
          }
        }
      };
    case ACCEPT_TERMS:
      return {
        ...state, terms_and_conditions: payload
      };
    case ORDER_SUCCESS:
      return {
        ...state, orderSuccess: payload
      };
    case CLEAR_STATE:
      return initialState(svs.ticket_partner.data.articles.ticketsPhysical);
    default:
      return state;
  }
};


 })(window);